import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ToolbarService } from './toolbar.service';
import { BrowserNotificationService } from 'app/services/browser-notification.service';

@Component({
  selector: 'admin-notifications-toolbar',
  templateUrl: './admin-notifications-toolbar.component.html',
  styleUrls: ['./admin-notifications-toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminNotificationsToolbarComponent implements OnInit, OnDestroy {
  enableNotify = new FormControl(false);

  constructor(
    private _toolbarService: ToolbarService,
    private browserNotificationService: BrowserNotificationService
  ) {}

  ngOnInit(): void {
    this.browserNotificationService.syncToggleControl(this.enableNotify);
  }

  get showBrowserNotifications(): boolean {
    return this.browserNotificationService.shouldHandleNotifications();
  }

  toggleNotifications(enabled: boolean): void {
    this.browserNotificationService.toggleNotificationControl(
      this.enableNotify,
      enabled,
      value => this._toolbarService.enableNotifyCallSource.next(value)
    );
  }

  ngOnDestroy(): void {
    this._toolbarService.enableNotifyCallSource.next(null);
  }
}
